import { compact } from 'components/utils';

export const ARTIFACT_TYPE_LABELS = {
  'Repo::Session': 'Interview',
  Clip: 'Highlight',
  Highlight: 'Note',
  HighlightReel: 'Highlight Reel',
  Story: 'Insight',
  ScreenerResponse: 'Survey Response',
  'Repo::File': 'File'
};

type Option = { label: string; value: string };

export const artifactTypeOptions = () =>
  compact(
    Object.entries(ARTIFACT_TYPE_LABELS).map(([value, label]) => ({
      label,
      value
    }))
  ) as Option[];
